/* ═══════════════════════════════════════════════════════════════════════════
   ОКНО-ВОРОНКА БРОНИРОВАНИЯ НА КАРТОЧКЕ ЖК  (перенос черновика, 21.08.2026)

   Владелец 20.08: «при клике забронировать окно должно быть на весь экран,
   тоже симпатичное по дизайну, подумай как воронку крутую сделать».
   Он же 21.08, найдя пропажу сам: «при клике "Выбрать квартиру" открылась
   обычная форма, а должна на весь экран с опросом-квизом».

   ─── ЧТО ЗА ВОРОНКА И ПОЧЕМУ ИМЕННО ТАКАЯ ─────────────────────────────────
   Раньше окно просило номер телефона сразу. Это самая дорогая просьба на
   странице, а человек к ней ещё ничем не обязан — отсюда и отказы. Здесь
   порядок обратный: сначала ТРИ лёгких вопроса по одному нажатию, и только
   потом номер, когда человек уже вложился ответами и видит, что подбор идёт
   лично под него.

     Шаг 1  «Какую квартиру ищете?»    — самый простой вопрос, входной билет.
     Шаг 2  «Как планируете оплату?»   — квалификация: от этого зависит разговор.
     Шаг 3  «Когда планируете?»        — срочность, она же приоритет для звонка.
     Шаг 4  «Куда позвонить»           — номер ПОСЛЕДНИМ + сводка ответов рядом.
     Готово «Что дальше»               — кто, когда и с чем перезвонит.

   Три вопроса, не шесть: каждый лишний шаг — это ещё одна дверь, чтобы уйти.
   Три ответа при этом уже делают заявку тёплой, менеджер звонит не вслепую.

   ⛔ ВАРИАНТ «ЕЩЁ ВЫБИРАЮ» НА ПЕРВОМ ШАГЕ УБИРАТЬ НЕЛЬЗЯ. Черновик его однажды
      спрятал, владелец посмотрел и вернул: «сейчас некрасиво смотрится, оставь
      как было». Форма быстрого ввода номера (`.zbo-quick`) — В ДОПОЛНЕНИЕ к
      нему, а не вместо.

   ─── ЧЕМ ЭТО НЕ ЛОМАЕТ СОСЕДЕЙ ────────────────────────────────────────────
   Старую шторку `#jkBottomSheet` НЕ трогаем и НЕ прячем: соседний блок уже
   вживил в неё галерею и форму, и подмена узлов сломала бы их. Свой узел
   `#zboWin` создаём сами и кладём в body — до шторки просто не доходит очередь.

   ⛔ Перехват, а не переподписка: кнопки `#jkHeroContact` и `#jkBbCta` уже
      слушают js/jk.js (`openLeadModal`, телефон) и js/jk-card.js
      (богатое окно с галереей, от 901 px). Ссылки на их обработчики у нас нет
      и снять их нечем. Ловим клик на ПОГРУЖЕНИИ (capture) и гасим — штатный
      путь не стартует, но и ничего чужого не отписано: сними этот файл из
      набора, и обе кнопки работают как раньше, строка в строку.
   ⛔ Метку источника заявки при этом СОХРАНЯЕМ пер-кнопочно (см. SRC ниже):
      перехват не должен обезличивать лиды.
   ⛔ Разметку страницы не трогаем вовсе — ни один существующий id не удаляется
      и не дублируется. Копия чужого id ломает и обработчик источника, и сторожа
      tests/JS/jk-card-lead-source.test.js.
   ═══════════════════════════════════════════════════════════════════════════ */

(() => {
  'use strict';

  // Повторный запуск (пересборка черновика, второй впрыск файла) не должен
  // вешать второй комплект обработчиков — иначе один клик открывал бы окно дважды.
  if (window.__zboWinReady) return;
  window.__zboWinReady = true;

  const TEL_FALLBACK = 'tel:+79191701918';

  // ─────────────────────────────────────────────────────────────────────────
  // Мелкая утварь
  // ─────────────────────────────────────────────────────────────────────────
  const el = (tag, cls, txt) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  };

  /** Значок. ⛔ Имена сверены с урезанным набором public/css/fontawesome/css/subset.min.css:
   *  отсутствующий там значок рисуется пустым квадратом, а не «ничем». */
  const ico = (name, cls) => {
    const i = document.createElement('i');
    i.className = (cls ? cls + ' ' : '') + 'fas ' + name;
    i.setAttribute('aria-hidden', 'true');
    return i;
  };

  const bw = () => document.getElementById('jkBuyWays');

  /** Название ЖК. Источники по убыванию надёжности: атрибут блока «Способы
   *  покупки» (сервер кладёт его в разметку), затем глобаль jk.js, затем H1. */
  function jkName() {
    let raw = '';
    const host = bw();
    if (host && host.dataset.jkName) raw = host.dataset.jkName;
    if (!raw && window.JK && window.JK.name) raw = String(window.JK.name);
    if (!raw) {
      const h1 = document.querySelector('h1');
      if (h1) raw = h1.textContent.trim();
    }
    raw = raw.replace(/\s+/g, ' ').trim();
    if (!raw) return 'жилом комплексе';
    // Если имя уже несёт «ЖК» — второй раз не приписываем.
    return /жк/i.test(raw) ? raw : 'ЖК «' + raw + '»';
  }

  /** Цена «от» словами. Число берём из разметки, а не считаем сами:
   *  свой подсчёт разошёлся бы с тем, что написано в блоке «Способы покупки». */
  function priceFrom() {
    const host = bw();
    let n = host && host.dataset.priceDef ? Number(host.dataset.priceDef) : 0;
    if (!n && host && host.dataset.priceMin) n = Number(host.dataset.priceMin);
    if (!n && window.JK && window.JK.priceFrom) n = Number(window.JK.priceFrom);
    if (!isFinite(n) || n <= 0) return '';
    if (n >= 1e6) {
      const m = n / 1e6;
      return (m >= 10 ? m.toFixed(0) : m.toFixed(2)).replace('.', ',') + ' млн ₽';
    }
    return Math.round(n / 1e3) + ' тыс ₽';
  }

  /** Ссылка «Позвонить». Читаем номер со страницы, а не держим константу:
   *  зашитый номер однажды разъедется с настоящим и никто этого не заметит. */
  function telHref() {
    const a = document.querySelector('.jk-bb-phone[href^="tel:"], a[href^="tel:"]');
    return a ? a.getAttribute('href') : TEL_FALLBACK;
  }

  /** Кадры для галереи. ⛔ Своих фотографий у окна нет и выдумывать пути нельзя:
   *  берём готовый список уже сжатых кадров (img-thumb, w=640) из атрибута
   *  `data-shots`, запасной источник — галерея описания ЖК на этой же странице. */
  function shots() {
    const out = [];
    const push = (s) => { if (s && out.indexOf(s) === -1) out.push(s); };
    const host = bw();
    if (host && host.dataset.shots) {
      try {
        const arr = JSON.parse(host.dataset.shots);
        if (Array.isArray(arr)) arr.forEach((s) => { if (typeof s === 'string') push(s); });
      } catch (e) { /* список поехал — уходим на запасной источник */ }
    }
    if (out.length < 2) {
      document.querySelectorAll('.jk-about__gal img, .jk-hero-slide img').forEach((img) => {
        const src = img.getAttribute('src');
        // ⛔ Только через сжиматель: оригиналы с чужих хостингов весят мегабайты.
        if (src && src.indexOf('/img-thumb.php') === 0) push(src);
      });
    }
    return out;
  }

  const digits = (v) => {
    let d = String(v == null ? '' : v).replace(/\D/g, '');
    if (d[0] === '8' || d[0] === '7') d = d.slice(1);   // код страны, а не первая цифра номера
    return d.slice(0, 10);
  };

  // ─────────────────────────────────────────────────────────────────────────
  // Вопросы воронки
  //
  // Подписи под вариантами намеренно осторожные («посчитаем», «уточним»):
  // обещать скидку или ставку, которых мы не знаем, — это ложь на первом же
  // звонке, и заявка сгорает вместе с доверием.
  // ─────────────────────────────────────────────────────────────────────────
  const STEPS = [
    {
      key: 'rooms',
      label: 'Квартира',
      q: 'Какую квартиру ищете?',
      hint: 'Одно нажатие — и дальше. Покажем только то, что реально свободно.',
      grid: true,
      opts: [
        { v: 'Студия', i: 'fa-th-large' },
        { v: '1 комната', i: 'fa-bed' },
        { v: '2 комнаты', i: 'fa-couch' },
        { v: '3 и больше', i: 'fa-home' },
        { v: 'Ещё выбираю', i: 'fa-search', wide: true }
      ]
    },
    {
      key: 'pay',
      label: 'Оплата',
      q: 'Как планируете оплату?',
      hint: 'От этого зависит и цена, и что мы будем считать к звонку.',
      opts: [
        { v: 'Ипотека', i: 'fa-percent', sub: 'Посчитаем платёж и подберём банк' },
        { v: 'Полная оплата', i: 'fa-wallet', sub: 'Уточним условия у застройщика' },
        { v: 'Рассрочка', i: 'fa-calendar-alt', sub: 'Проверим, даёт ли её этот ЖК' },
        { v: 'Материнский капитал', i: 'fa-gift', sub: 'Поможем с документами' },
        { v: 'Пока не решил', i: 'fa-comments', sub: 'Разберём варианты на звонке' }
      ]
    },
    {
      key: 'when',
      label: 'Срок',
      q: 'Когда планируете покупку?',
      hint: 'Скажем честно, доживёт ли выбранная цена до этого срока.',
      opts: [
        { v: 'В ближайший месяц', i: 'fa-bolt', sub: 'Возьмём в работу первым' },
        { v: 'Через 2–3 месяца', i: 'fa-clock', sub: 'Придержим подходящие варианты' },
        { v: 'В течение полугода', i: 'fa-calendar-alt', sub: 'Предупредим о росте цен' },
        { v: 'Пока присматриваюсь', i: 'fa-eye', sub: 'Просто пришлём подборку' }
      ]
    }
  ];

  const PERKS = [
    { i: 'fa-lock', t: 'Цену фиксируем в день заявки' },
    { i: 'fa-handshake', t: 'Без комиссии — платит застройщик' },
    { i: 'fa-file-signature', t: 'Бронь и сделка онлайн' }
  ];

  // ─────────────────────────────────────────────────────────────────────────
  // Состояние. Живёт между открытиями окна: закрыл на третьем шаге, вернулся —
  // ответы на месте и мы возвращаем на тот же шаг. Это прямое требование
  // «закрыл шаг — не потерял ответы», а заодно снимает страх нажать крестик.
  // ─────────────────────────────────────────────────────────────────────────
  const state = { at: 0, ans: {}, sent: false };

  // ─────────────────────────────────────────────────────────────────────────
  // Метка источника заявки — ПО КНОПКЕ, а не одна на всё окно.
  //
  // ⛔ Черновик слал всем одну строку «Карточка ЖК — окно бронирования», и это
  //    молча стирало бы разницу между точками входа: в js/jk-card.js под каждый
  //    id карточки заведена своя человеческая метка (CARD_LEAD_SOURCES), она
  //    уходит в письмо и в Telegram, и по ней владелец видит, какая кнопка
  //    приносит звонки. Поломка была бы невидимой — заявки идут, письма
  //    приходят, просто все «из окна бронирования».
  // ⛔ Подписи ДОСЛОВНО те же, что в CARD_LEAD_SOURCES: два списка с одним
  //    смыслом расходятся всегда, и разойдясь дали бы в отчёте два источника
  //    вместо одного — на глаз не отличить от роста трафика.
  // ─────────────────────────────────────────────────────────────────────────
  const SRC = {
    jkHeroContact: 'первый экран — выбор квартир',
    jkBbCta: 'нижняя панель'
  };
  let cameFrom = '';

  let win = null;      // корень окна
  let box = null;      // сама коробка
  let bodyBox = null;  // прокручиваемая середина
  let backBtn = null;
  let countEl = null;
  let stepNodes = [];
  let doneNode = null;
  let contactBox = null;   // блок, куда пересобираются чипы сводки
  let phoneInp = null;
  let agreeInp = null;
  let errEl = null;
  let sendBtn = null;
  let hopTimer = 0;
  let lastFocus = null;

  // ─────────────────────────────────────────────────────────────────────────
  // Галерея рендеров
  // ─────────────────────────────────────────────────────────────────────────
  function buildGallery() {
    const list = shots();
    const g = el('div', 'zbo-gal');

    if (list.length) {
      const img = document.createElement('img');
      img.className = 'zbo-gal__img';
      img.alt = 'Рендер ' + jkName();
      img.decoding = 'async';
      g.appendChild(img);

      let at = 0;
      let dots = null;

      const show = () => {
        img.setAttribute('src', list[at]);
        if (dots) [].forEach.call(dots.children, (d, i) => d.classList.toggle('is-on', i === at));
        // Соседние кадры тянем заранее: иначе первое нажатие стрелки даёт
        // пустой прямоугольник на полсекунды.
        [at + 1, at - 1].forEach((k) => {
          const s = list[(k + list.length) % list.length];
          if (s) { const pre = new Image(); pre.src = s; }
        });
      };
      const step = (d) => { at = (at + d + list.length) % list.length; show(); };

      if (list.length > 1) {
        const arrow = (dir, label, glyph) => {
          const b = el('button', 'zbo-gal__nav zbo-gal__nav--' + dir, glyph);
          b.type = 'button';
          b.setAttribute('aria-label', label);
          b.addEventListener('click', (e) => {
            // ⛔ Гасим всплытие: клик по подложке окна закрывает его, и стрелка
            //    без этого захлопывала бы окно вместо листания.
            e.preventDefault();
            e.stopPropagation();
            step(dir === 'prev' ? -1 : 1);
          });
          return b;
        };
        g.appendChild(arrow('prev', 'Предыдущий кадр', '‹'));
        g.appendChild(arrow('next', 'Следующий кадр', '›'));

        dots = el('div', 'zbo-gal__dots');
        list.forEach(() => dots.appendChild(el('span', 'zbo-gal__dot')));
        g.appendChild(dots);

        // Свайп по кадру. Порог по X больше, чем по Y, — иначе вертикальная
        // прокрутка окна засчитывалась бы как листание.
        let x0 = 0;
        let y0 = 0;
        g.addEventListener('touchstart', (e) => {
          x0 = e.touches[0].clientX;
          y0 = e.touches[0].clientY;
        }, { passive: true });
        g.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - x0;
          const dy = e.changedTouches[0].clientY - y0;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
        }, { passive: true });
      }
      show();
    }

    g.appendChild(el('div', 'zbo-gal__shade'));

    // Имя ЖК и цена «от» — то самое «ради чего», и они не уезжают ни на одном шаге.
    const cap = el('div', 'zbo-gal__cap');
    cap.appendChild(el('div', 'zbo-gal__jk', jkName()));
    const price = priceFrom();
    if (price) {
      const p = el('div', 'zbo-gal__price');
      p.appendChild(el('span', null, 'от'));
      p.appendChild(el('b', null, price));
      cap.appendChild(p);
    }
    g.appendChild(cap);
    return g;
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Шаг с вариантами ответа
  // ─────────────────────────────────────────────────────────────────────────
  function buildStep(cfg, idx) {
    const s = el('div', 'zbo-step');
    const h = el('div', 'zbo-q', cfg.q);
    h.setAttribute('tabindex', '-1');   // чтобы после перехода было куда увести фокус
    s.appendChild(h);
    s.appendChild(el('div', 'zbo-hint', cfg.hint));

    const opts = el('div', 'zbo-opts' + (cfg.grid ? ' zbo-opts--grid' : ''));
    cfg.opts.forEach((o) => {
      const b = el('button', 'zbo-opt' + (o.wide ? ' zbo-opt--wide' : ''));
      b.type = 'button';
      b.dataset.zboVal = o.v;
      b.setAttribute('aria-pressed', 'false');

      const ib = el('span', 'zbo-opt__ico');
      ib.appendChild(ico(o.i));
      b.appendChild(ib);

      const t = el('span', 'zbo-opt__txt');
      t.appendChild(el('span', 'zbo-opt__ttl', o.v));
      if (o.sub && !cfg.grid) t.appendChild(el('span', 'zbo-opt__sub', o.sub));
      b.appendChild(t);

      const mark = el('span', 'zbo-opt__mark');
      mark.appendChild(ico('fa-check-circle'));
      b.appendChild(mark);

      b.addEventListener('click', () => {
        state.ans[cfg.key] = o.v;
        markStep(idx);
        // Небольшая пауза: без неё выбранный вариант не успевает подсветиться,
        // и нажатие выглядит как «экран сам куда-то дёрнулся».
        clearTimeout(hopTimer);
        hopTimer = setTimeout(() => go(idx + 1), 190);
      });
      opts.appendChild(b);
    });
    s.appendChild(opts);
    return s;
  }

  /** Подсветить ранее выбранный вариант — возврат назад должен показывать ответ. */
  function markStep(idx) {
    const cfg = STEPS[idx];
    const cur = state.ans[cfg.key] || '';
    stepNodes[idx].querySelectorAll('.zbo-opt').forEach((b) => {
      const on = b.dataset.zboVal === cur;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Шаг 4 — контакт
  // ─────────────────────────────────────────────────────────────────────────
  function buildContact() {
    const s = el('div', 'zbo-step');

    const h = el('div', 'zbo-q', 'Куда прислать подборку?');
    h.setAttribute('tabindex', '-1');
    s.appendChild(h);
    s.appendChild(el('div', 'zbo-hint', 'Остался один шаг. Перезвоним в течение 15 минут в рабочее время, номер никому не передаём.'));

    // Сводка ответов. Она тут не для красоты: человек видит, что уже вложился,
    // и это самый сильный довод дойти до конца. Плюс каждый чип — путь назад.
    contactBox = el('div', 'zbo-chips');
    s.appendChild(contactBox);

    const form = el('form', 'zbo-form');
    form.setAttribute('novalidate', 'novalidate');

    phoneInp = document.createElement('input');
    phoneInp.type = 'tel';
    phoneInp.className = 'zbo-input ym-hide-content';
    phoneInp.autocomplete = 'tel';
    phoneInp.placeholder = '+7 (___) ___-__-__';
    phoneInp.setAttribute('aria-label', 'Телефон');
    // Номер не должен попадать в Вебвизор — те же метки, что у штатных полей.
    phoneInp.setAttribute('data-ym-disable-keys', 'true');
    form.appendChild(phoneInp);

    errEl = el('div', 'zbo-err', 'Введите телефон полностью');
    errEl.setAttribute('role', 'alert');
    form.appendChild(errEl);

    // ⛔ 152-ФЗ ст. 9 ч. 1: согласие со ссылкой на текст — юридическое требование,
    //    снимать нельзя ни при какой перерисовке окна.
    const lbl = el('label', 'zbo-agree');
    agreeInp = document.createElement('input');
    agreeInp.type = 'checkbox';
    lbl.appendChild(agreeInp);
    const tick = el('span', 'zbo-tick', '✓');
    tick.setAttribute('aria-hidden', 'true');
    lbl.appendChild(tick);
    const txt = el('span');
    txt.appendChild(document.createTextNode('Согласен на обработку моих персональных данных (имя, телефон). '));
    const a = document.createElement('a');
    a.href = '/soglasie.php';
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = 'Согласие на обработку ПДн';
    txt.appendChild(a);
    lbl.appendChild(txt);
    form.appendChild(lbl);

    sendBtn = el('button', 'zbo-send');
    sendBtn.type = 'submit';
    sendBtn.appendChild(ico('fa-paper-plane'));
    sendBtn.appendChild(el('span', null, 'Забронировать цену'));
    form.appendChild(sendBtn);

    phoneInp.addEventListener('input', () => {
      const d = digits(phoneInp.value);
      if (!d.length) { phoneInp.value = ''; return; }
      let out = '+7 (' + d.slice(0, 3);
      if (d.length >= 4) out += ') ' + d.slice(3, 6);
      if (d.length >= 7) out += '-' + d.slice(6, 8);
      if (d.length >= 9) out += '-' + d.slice(8, 10);
      phoneInp.value = out;
      if (d.length === 10) { phoneInp.classList.remove('is-bad'); errEl.classList.remove('is-on'); }
    });

    form.addEventListener('submit', submit);
    s.appendChild(form);
    return s;
  }

  /** Пересобрать чипы сводки — ответы могли поменяться после возврата назад. */
  function fillChips() {
    if (!contactBox) return;
    contactBox.textContent = '';
    STEPS.forEach((cfg, i) => {
      const v = state.ans[cfg.key];
      if (!v) return;
      const c = el('button', 'zbo-chip');
      c.type = 'button';
      c.setAttribute('aria-label', cfg.label + ': ' + v + '. Нажмите, чтобы изменить');
      c.appendChild(document.createTextNode(v));
      c.appendChild(ico('fa-pen'));
      c.addEventListener('click', () => go(i));
      contactBox.appendChild(c);
    });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Экран «принято»
  // ─────────────────────────────────────────────────────────────────────────
  function buildDone() {
    const s = el('div', 'zbo-step zbo-done');

    const ib = el('div', 'zbo-done__ico');
    ib.appendChild(ico('fa-check'));
    s.appendChild(ib);

    const t = el('div', 'zbo-done__t', 'Заявка принята');
    t.setAttribute('tabindex', '-1');
    s.appendChild(t);
    s.appendChild(el('div', 'zbo-done__s', 'Мы уже видим ваш запрос. Дальше по шагам:'));

    // Человек должен уходить, ЗНАЯ кто и когда позвонит. Без этого он через
    // минуту наберёт следующий сайт из выдачи «на всякий случай».
    const plan = el('ul', 'zbo-plan');
    [
      { i: 'fa-bolt', w: 'Прямо сейчас', s: 'Заявка ушла менеджеру вместе с вашими ответами — пересказывать их по телефону не придётся.' },
      { i: 'fa-phone', w: 'В течение 15 минут', s: 'Перезвоним в рабочее время. Если сейчас ночь — наберём утром.' },
      { i: 'fa-key', w: 'На звонке', s: 'Назовём свободные квартиры под ваш запрос и зафиксируем цену на выбранную.' }
    ].forEach((r) => {
      const li = document.createElement('li');
      li.appendChild(ico(r.i));
      const wrap = el('div');
      wrap.appendChild(el('b', null, r.w));
      wrap.appendChild(el('span', null, r.s));
      li.appendChild(wrap);
      plan.appendChild(li);
    });
    s.appendChild(plan);
    return s;
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Отправка
  // ─────────────────────────────────────────────────────────────────────────
  function submit(e) {
    e.preventDefault();
    const d = digits(phoneInp.value);
    if (d.length !== 10) {
      phoneInp.classList.add('is-bad');
      errEl.textContent = 'Введите телефон полностью';
      errEl.classList.add('is-on');
      phoneInp.focus();
      return;
    }
    // ⛔ Шлём РЕАЛЬНОЕ состояние флажка, а не единицу константой: строка уходит
    //    в журнал согласий, который показывают РКН.
    if (!agreeInp.checked) {
      if (typeof window.showConsentHint === 'function') window.showConsentHint(agreeInp);
      errEl.textContent = 'Отметьте согласие на обработку персональных данных';
      errEl.classList.add('is-on');
      return;
    }

    sendBtn.disabled = true;
    // ⛔ Прежний вид кнопки запоминаем УЗЛАМИ, а не строкой innerHTML: канал
    //    записи разметки в проекте закрыт целиком, и «мы же кладём обратно своё»
    //    — ровно то оправдание, с которого такие дыры и начинаются. Узлы к тому
    //    же переживают возврат целыми, вместе со значком.
    const wasNodes = [...sendBtn.childNodes];
    sendBtn.textContent = 'Отправляем…';

    const body = new URLSearchParams();
    // ⛔ Скрытые поля (_csrf, _subject, _replyto) забираем у штатной формы:
    //    свой токен мы не выпишем, а без него send.php ответит 403.
    const native = document.getElementById('callbackForm');
    if (native) {
      native.querySelectorAll('input[type=hidden]').forEach((h) => { if (h.name) body.append(h.name, h.value); });
    } else if (window._csrfToken) {
      body.append('_csrf', window._csrfToken);
    }
    // Ловушка для роботов: у неё type=text + атрибут hidden, под селектор
    // скрытых полей выше она не попадает, поэтому добавляем руками.
    body.append('_hp', '');

    const parts = STEPS.map((c) => state.ans[c.key] ? c.label + ': ' + state.ans[c.key] : null).filter(Boolean);
    body.append('name', 'Заявка с карточки ЖК');
    body.append('phone', '+7' + d);
    body.append('consent_main', '1');
    // Страница комнатности называет себя сама (window.BRONI_LEAD_PAGE, flats.php).
    const page = typeof window.BRONI_LEAD_PAGE === 'string' && window.BRONI_LEAD_PAGE ? window.BRONI_LEAD_PAGE : 'Карточка ЖК';
    body.append('_source', page + ' — ' + (SRC[cameFrom] || 'окно бронирования'));
    body.append('comment', 'Бронирование ' + jkName() + (parts.length ? '. ' + parts.join('. ') : ''));

    fetch('/send.php', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    })
      // ⛔ Без проверки r.ok «Заявка принята» рисовалась бы и на 403 при
      //    непрошедшем CSRF: человек уходит довольным, а заявки нет.
      .then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r; })
      .then(() => {
        state.sent = true;
        finish();
        if (typeof window.ymGoal === 'function') window.ymGoal('jk_callback_modal_sent');
      })
      .catch(() => {
        sendBtn.disabled = false;
        sendBtn.textContent = '';
        wasNodes.forEach((n) => sendBtn.appendChild(n));
        errEl.textContent = 'Не получилось отправить. Попробуйте ещё раз или позвоните нам.';
        errEl.classList.add('is-on');
      });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Переходы между шагами
  // ─────────────────────────────────────────────────────────────────────────
  const SCLS = ['is-s1', 'is-s2', 'is-s3', 'is-s4', 'is-done'];

  function setStepClass(name) {
    SCLS.forEach((c) => box.classList.remove(c));
    box.classList.add(name);
  }

  function go(n) {
    if (!win) return;
    clearTimeout(hopTimer);
    n = Math.max(0, Math.min(STEPS.length, n));   // 0..3, где 3 — контакт
    state.at = n;

    stepNodes.forEach((s, i) => s.classList.toggle('is-live', i === n));
    doneNode.classList.remove('is-live');

    setStepClass('is-s' + (n + 1));
    backBtn.hidden = n === 0;
    countEl.textContent = '';
    countEl.appendChild(el('b', null, 'Шаг ' + (n + 1)));
    countEl.appendChild(document.createTextNode(' из ' + (STEPS.length + 1)));

    if (n < STEPS.length) markStep(n);
    else fillChips();

    bodyBox.scrollTop = 0;

    // Фокус уводим на заголовок шага — читалка озвучит новый вопрос.
    // ⛔ Поле телефона фокусируем только на компе: на телефоне всплывающая
    //    клавиатура тут же перекроила бы половину окна.
    const head = stepNodes[n].querySelector('.zbo-q');
    if (head) head.focus({ preventScroll: true });
    if (n === STEPS.length && phoneInp && window.matchMedia && window.matchMedia('(min-width: 901px)').matches) {
      setTimeout(() => phoneInp.focus({ preventScroll: true }), 120);
    }
  }

  function finish() {
    stepNodes.forEach((s) => s.classList.remove('is-live'));
    doneNode.classList.add('is-live');
    setStepClass('is-done');
    backBtn.hidden = true;
    countEl.textContent = 'Готово';
    bodyBox.scrollTop = 0;
    const t = doneNode.querySelector('.zbo-done__t');
    if (t) t.focus({ preventScroll: true });
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Сборка окна (один раз, при первом открытии)
  // ─────────────────────────────────────────────────────────────────────────
  function build() {
    if (win) return;

    win = el('div', 'zbo-win');
    win.id = 'zboWin';
    win.hidden = true;

    const veil = el('div', 'zbo-veil');
    veil.addEventListener('click', close);
    win.appendChild(veil);

    box = el('div', 'zbo-box');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Бронирование квартиры');
    box.setAttribute('tabindex', '-1');

    const x = el('button', 'zbo-x');
    x.type = 'button';
    x.setAttribute('aria-label', 'Закрыть');
    x.appendChild(ico('fa-times'));
    x.addEventListener('click', close);
    box.appendChild(x);

    // ─ левая часть: обещание ─
    const aside = el('aside', 'zbo-aside');
    aside.appendChild(buildGallery());
    const perks = el('ul', 'zbo-perks');
    PERKS.forEach((p) => {
      const li = el('li', 'zbo-perk');
      li.appendChild(ico(p.i));
      li.appendChild(el('span', null, p.t));
      perks.appendChild(li);
    });
    aside.appendChild(perks);
    box.appendChild(aside);

    // ─ правая часть: воронка ─
    const main = el('div', 'zbo-main');

    const head = el('div', 'zbo-head');
    const row = el('div', 'zbo-headrow');
    backBtn = el('button', 'zbo-back');
    backBtn.type = 'button';
    backBtn.appendChild(ico('fa-chevron-left'));
    backBtn.appendChild(el('span', null, 'Назад'));
    backBtn.addEventListener('click', () => go(state.at - 1));
    row.appendChild(backBtn);

    countEl = el('div', 'zbo-count');
    countEl.setAttribute('aria-live', 'polite');
    row.appendChild(countEl);
    head.appendChild(row);

    const track = el('div', 'zbo-track');
    track.appendChild(el('div', 'zbo-fill'));
    head.appendChild(track);
    main.appendChild(head);

    bodyBox = el('div', 'zbo-body');
    stepNodes = STEPS.map((cfg, i) => buildStep(cfg, i));
    stepNodes.push(buildContact());
    stepNodes.forEach((s) => bodyBox.appendChild(s));
    doneNode = buildDone();
    bodyBox.appendChild(doneNode);
    main.appendChild(bodyBox);

    const foot = el('div', 'zbo-foot');
    const call = el('a', 'zbo-call');
    call.href = telHref();
    call.appendChild(ico('fa-phone'));
    call.appendChild(el('span', null, 'Позвонить'));
    foot.appendChild(call);
    foot.appendChild(el('div', 'zbo-note', 'Отвечаем в рабочее время. Номер используем только для этой заявки.'));
    main.appendChild(foot);

    box.appendChild(main);
    win.appendChild(box);
    document.body.appendChild(win);

    // Ловушка фокуса: пока окно открыто, Tab не должен уводить на страницу под ним.
    box.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const able = box.querySelectorAll('a[href], button:not([disabled]), input, [tabindex="0"]');
      const live = [].filter.call(able, (n) => n.offsetParent !== null || n === document.activeElement);
      if (!live.length) return;
      const first = live[0];
      const last = live[live.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    syncQuick();
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Быстрая форма номера прямо на первом шаге — для тех, кто не хочет отвечать
  // на вопросы. Владелец 20.08: «сделай там именно форму ввода номера, а не
  // "хочу просто оставить номер"» и «лишние окна» — то есть без перескока.
  //
  // ⛔ Отправку НЕ ДУБЛИРУЕМ. Форма только собирает номер и согласие, а шлёт
  //    настоящая форма окна (`.zbo-form`): в ней CSRF, скрытые поля и разбор
  //    ответа. Второй отправщик с тем же смыслом разошёлся бы с первым на
  //    первой же правке — проект на таком уже горел.
  // ⛔ Только на телефоне: на компьютере всё оформление `.zbo-quick` лежит вне
  //    (max-width:900px), а рядом и так стоит крупное поле номера на шаге 4.
  // ─────────────────────────────────────────────────────────────────────────
  const PHONE_MQ = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
  const isPhone = () => (PHONE_MQ ? PHONE_MQ.matches : window.innerWidth <= 900);

  let quickBox = null;

  function buildQuick() {
    if (quickBox || !bodyBox || !phoneInp) return;

    const wrap = el('div', 'zbo-quick');

    // ⛔ ЗАГОЛОВКА «Или сразу оставьте номер — перезвоним и подберём» БОЛЬШЕ НЕТ.
    //    Владелец 21.08: «оставь только номер для ввода и галочку… всё
    //    максимально проще». Две строки над полем с маской «+7 (___) ___-__-__»
    //    и кнопкой рядом стоили 28 px и не говорили ничего, чего не видно по
    //    самому полю. Оформление `.zbo-quick__title` удалено из CSS вместе с
    //    узлом — правила без узла обещают читающему то, чего на экране нет.
    const row = el('div', 'zbo-quick__row');
    const phone = document.createElement('input');
    phone.type = 'tel';
    phone.className = 'zbo-quick__input ym-hide-content';
    phone.placeholder = '+7 (___) ___-__-__';
    phone.autocomplete = 'tel';
    // Номер — персональные данные: в Вебвизор он попадать не должен, метки те же,
    // что у штатных полей формы.
    phone.setAttribute('data-ym-disable-keys', 'true');
    phone.setAttribute('aria-label', 'Телефон');
    row.appendChild(phone);

    // ⛔ «Отправить», а не «Жду звонка». 21.08 из окна убрана кнопка
    //    «Позвонить» (владелец: «и "позвонить" тоже убери»), и «Жду звонка»
    //    осталось бы единственной надписью про звонок ровно там, откуда звонок
    //    убрали. Один короткий глагол про то, что произойдёт по нажатию.
    const send = el('button', 'zbo-quick__btn', 'Отправить');
    send.type = 'button';
    row.appendChild(send);
    wrap.appendChild(row);

    // ⛔ ТЕКСТ СОГЛАСИЯ ДОСЛОВНО ТОТ ЖЕ, что в остальных формах карточки
    //    (js/jk-card.js, js/jk-buy-ways.js, js/jk-compact.js, js/booking-modal.js).
    //    В черновике здесь стояла своя короткая формулировка — а номер версии
    //    согласия в базе один на все формы, и разные тексты под одной версией
    //    означают, что журнал для РКН не отвечает на вопрос «с чем согласились».
    const lbl = el('label', 'zbo-quick__agree');
    const chk = document.createElement('input');
    chk.type = 'checkbox';
    lbl.appendChild(chk);
    const tick = el('span', 'zbo-quick__tick');
    tick.setAttribute('aria-hidden', 'true');
    lbl.appendChild(tick);
    const txt = el('span');
    txt.appendChild(document.createTextNode('Согласен на обработку моих персональных данных (имя, телефон). '));
    const a = document.createElement('a');
    a.href = '/soglasie.php';
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = 'Согласие на обработку ПДн';
    txt.appendChild(a);
    lbl.appendChild(txt);
    wrap.appendChild(lbl);

    const hint = el('div', 'zbo-quick__hint');
    wrap.appendChild(hint);

    send.addEventListener('click', () => {
      if (digits(phone.value).length !== 10) {
        hint.textContent = 'Введите номер телефона';
        phone.focus();
        return;
      }
      if (!chk.checked) {
        hint.textContent = 'Отметьте согласие на обработку персональных данных';
        return;
      }
      hint.textContent = '';
      // Переливаем в настоящую форму и жмём её кнопку: отправка одна на всех.
      phoneInp.value = phone.value;
      phoneInp.dispatchEvent(new Event('input', { bubbles: true }));
      if (agreeInp && !agreeInp.checked) {
        agreeInp.checked = true;
        agreeInp.dispatchEvent(new Event('change', { bubbles: true }));
      }
      submit(new Event('submit', { cancelable: true }));
    });

    // ⛔ Ссылка «Согласие на обработку ПДн» открывает вкладку, но клик по ней
    //    всплывает до подложки окна — без этого окно захлопывалось бы под рукой.
    a.addEventListener('click', (e) => e.stopPropagation());

    bodyBox.appendChild(wrap);
    quickBox = wrap;
  }

  /**
   * ⛔ Порог 900 px пересекается ПОВОРОТОМ телефона (405×928 → 928×405), а не
   *    только перетаскиванием окна мышью. Черновик решал «телефон или компьютер»
   *    ОДИН раз при загрузке файла — то есть на альбомной ориентации формы не
   *    было бы никогда, даже после возврата в портрет. Слушаем `change` в ОБЕ
   *    стороны; парная страховка — правило `@media (min-width:901px)` в CSS.
   */
  function syncQuick() {
    if (!win) return;
    if (isPhone()) { buildQuick(); return; }
    if (quickBox) { quickBox.remove(); quickBox = null; }
  }

  if (PHONE_MQ) {
    if (typeof PHONE_MQ.addEventListener === 'function') PHONE_MQ.addEventListener('change', syncQuick);
    else if (typeof PHONE_MQ.addListener === 'function') PHONE_MQ.addListener(syncQuick);
  }

  // ─────────────────────────────────────────────────────────────────────────
  // Открыть / закрыть
  // ─────────────────────────────────────────────────────────────────────────
  function open() {
    build();
    if (win.classList.contains('is-open')) return;   // второй клик подряд ничего не ломает

    // Страховка: если штатная шторка всё же успела открыться, гасим её —
    // иначе она осталась бы висеть под нашим окном.
    ['jkBottomSheet', 'jkSheetOverlay'].forEach((id) => {
      const n = document.getElementById(id);
      if (n) n.classList.remove('open');
    });

    // Пересборка быстрой формы при каждом открытии: между двумя открытиями
    // экран мог сменить ориентацию, а окно строится ровно один раз.
    syncQuick();

    lastFocus = document.activeElement;
    win.hidden = false;
    win.classList.add('is-open');
    // ⛔ Замок прокрутки классом, а не body.style.overflow: jk.js пишет в тот же
    //    инлайновый стиль для своей шторки, и мы бы затирали друг друга.
    document.documentElement.classList.add('zbo-lock');
    document.body.classList.add('zbo-lock');

    if (state.sent) finish();
    else go(state.at);

    if (typeof window.ymGoal === 'function') window.ymGoal('jk_book_window_open');
  }

  function close() {
    if (!win || !win.classList.contains('is-open')) return;
    clearTimeout(hopTimer);
    win.classList.remove('is-open');
    win.hidden = true;
    document.documentElement.classList.remove('zbo-lock');
    document.body.classList.remove('zbo-lock');
    // Возвращаем фокус туда, откуда пришли, — иначе он падает в начало страницы.
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && win && win.classList.contains('is-open')) close();
  });

  // ─────────────────────────────────────────────────────────────────────────
  // Перехват кликов
  //
  // Ловим на ПОГРУЖЕНИИ и гасим: обработчики jk.js висят на самих кнопках, а
  // до них событие в этой фазе ещё не дошло. Так старое окно не открывается,
  // и при этом мы ничего у соседей не отписываем.
  //
  // Соседний черновик тоже слушает `#jkHeroContact` и переводит нажатие на
  // `#jkBbCta` программным кликом. Этот программный клик — тоже событие, мы
  // поймаем и его, а повторное open() уже ничего не делает.
  // ─────────────────────────────────────────────────────────────────────────
  const HOOK = '#jkHeroContact, #jkBbCta';

  document.addEventListener('click', (e) => {
    if (!e.target || !e.target.closest) return;
    const btn = e.target.closest(HOOK);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    // ⛔ Запоминаем ДО открытия: метка источника уходит в заявку, и без неё обе
    //    кнопки слились бы в одну строку письма (см. SRC выше).
    if (btn.id && SRC[btn.id]) cameFrom = btn.id;
    open();
  }, true);
})();
